import React, { Component } from 'react'
import { connect } from 'react-redux'

// actions
import { setEmbeddedBookingCardata, saveEmbeddedBooking } from '../../../actions/embeddedbooking'
import { getOrderVehicleData } from '../../../actions/orders'

// Elements
import Text from '../../../shared/elements/text'
import Button from '../../../shared/elements/button'
import DropDown from '../../../shared/elements/dropDown'

// utils
import { translation } from '../../../utils/helpers'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// styles
import './cardataview.scss'
import Textarea from '../../../shared/elements/textarea'

class CarDataView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      CarData: {
        IsDirty: this.props.CarData.IsDirty,
        RegNumber: this.props.CarData.RegNumber,
        BrandNameId: this.props.CarData.BrandNameId,
        Model: this.props.CarData.Model,
        ChassisNumber: this.props.CarData.ChassisNumber,
        Km: this.props.CarData.Km,
        DamageComment: this.props.CarData.DamageComment
      },
      BrandNameError: false,
      ModelError: false,
      KmError: false
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onRegBlur = this.onRegBlur.bind(this)
    this.onRegNrChange = this.onRegNrChange.bind(this)
    this.checkAndNav = this.checkAndNav.bind(this)
  }

  componentDidMount () {
    this.setState({
      CarData: this.props.CarData
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    let names = e.target.name.split('.')
    if (names[1] === 'Km') value = parseInt(e.target.value)
    this.setState({
      CarData: {
        ...this.state.CarData,
        [names[1]]: value
      },
      BrandNameError: false,
      ModelError: false,
      KmError: false
    }, () => {
      if (names[1] === 'BrandNameId') {
        this.props.setEmbeddedBookingCardata(this.state.CarData)
        this.props.onBlur(e)
      }
    })
  }

  checkAndNav (e, opt) {
    e.persist()
    let { CarData } = this.state
    let brandNameError = CarData.BrandNameId === 1   // Unknown brand
    let modelError = CarData.Model === null || CarData.Model.length === 0
    let kmError = CarData.Km < 1
    if (brandNameError || modelError || kmError) {
      this.setState({
        BrandNameError: brandNameError,
        ModelError: modelError,
        KmError: kmError
      })
    } else {
      this.props.onNavClick(e, opt)
    }
  }

  onBlur (e) {
    this.props.onBlur(e)
  }

  onRegBlur () {
    return new Promise((resolve, reject) => {
      if (!this.state.CarData.RegNumber || this.state.CarData.RegNumber.length === 0) {
        let updateData = {
          CarData: {
            IsDirty: true,
            RegNumber: '',
            BrandNameId: null,
            Model: null,
            ChassisNumber: null,
            Km: null
          }
        }
        this.props.saveEmbeddedBooking(updateData).then(res => resolve && resolve())
        return
      }
      this.props.getOrderVehicleData(this.state.CarData.RegNumber, 'RegNumber').then(res => {
        this.setState({
          CarData: {
            ...this.state.CarData,
            RegNumber: res.data.RegNr,
            BrandNameId: res.data.BrandNameId,
            Model: res.data.Model,
            ChassisNumber: res.data.ChassisNumber
          },
          regNumberChecked: true
        }, () => {
          let updateData = {
            CarData: {
              IsDirty: true,
              RegNumber: this.state.CarData.RegNumber,
              BrandNameId: this.state.CarData.BrandNameId,
              Model: this.state.CarData.Model,
              ChassisNumber: this.state.CarData.ChassisNumber,
              Km: null
            }
          }
          this.props.saveEmbeddedBooking(updateData).then(res => resolve && resolve())
        })
      })
      .catch(() => {
        resolve && resolve()
      })
    })
  }

  onRegNrChange (e) {
    let value = e.target.value

    this.setState({
      CarData: {
        ...this.state.CarData,
        RegNumber: value
      },
      regNumberChecked: false,
      regNumberError: false
    })
  }

  render () {
    let { CarData } = this.state
    let requiredBrandNameClass = this.state.BrandNameError ? 'required' : ''
    let requiredModelClass = this.state.ModelError ? 'required' : ''
    let requiredKmClass = this.state.KmError ? 'required' : ''
    // <option value='0'>{translation(145)}</option>

    const renderWithRegFlow = () => {
      let leftChildren = true

      return (
        <div className='reg'>
          <article className='main'>
            {this.props.children}
            <h1>{translation(77)}</h1>
            <Text className={requiredKmClass} name='CarData.Km' value={CarData.Km || ''} onChange={this.onChange} onBlur={this.onBlur} helpText={translation(16846)} placeholder={translation(860)} />
            <Textarea name='CarData.DamageComment' placeholder={translation(1021)} value={CarData.DamageComment || ''} onChange={this.onChange} onBlur={this.onBlur} />
            <Text className={this.state.regNumberError ? 'required' : ''} name='CarData.RegNumber' value={CarData.RegNumber || ''} onChange={this.onRegNrChange} onBlur={this.onRegBlur} placeholder={translation(2005)} />
            <DropDown className={requiredBrandNameClass} name='CarData.BrandNameId' value={CarData.BrandNameId} onChange={this.onChange}>
              {this.props.Brands.map((val, index) => {
                let brandName = val.Id === 1 ? translation(val.Name) : val.Name
                return val.Id === this.state.CarData.BrandNameId ? <option value={val.Id} key={index} selected>{brandName}</option> : <option value={val.Id} key={index}>{brandName}</option>
              })}
            </DropDown>
            <Text className={requiredModelClass} name='CarData.Model' value={CarData.Model || ''} onChange={this.onChange} onBlur={this.onBlur} placeholder={translation(146)} />
            <Text name='CarData.ChassisNumber' value={CarData.ChassisNumber || ''} onChange={this.onChange} onBlur={this.onBlur} helpText={translation(16845)} placeholder={translation(81)} />
            <div className='ctaWrapper'>
              <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} leftChildren={leftChildren}>
                <Icon
                  size='s'
                  icon={EmbeddedBookingIcons.Left_Arrow}
                  injectSvg
                />
              </Button>
              <Button labelText={translation(237)} onClick={(e) => this.checkAndNav(e, 'next')}>
                <Icon
                  size='s'
                  icon={EmbeddedBookingIcons.Right_Arrow}
                  injectSvg
                />
              </Button>
            </div>
          </article>
          <aside className='side'>
            <section>
              <h1>{translation(18432)}</h1>
              <p>{translation(18433)}</p>
              <ul>
                <li>{translation(18434)}</li>
                <li>{translation(18435)}</li>
                <li>{translation(18436)}</li>
              </ul>
            </section>
          </aside>
        </div>
      )
    }

    const renderNoRegFlow = () => {
      // <option value='0'>{translation(145)}</option>
      let leftChildren = true
      return (
        <div className='noReg'>
          <article className='main'>
            {this.props.children}
            <h1>{translation(77)}</h1>
            <Text className={requiredKmClass} name='CarData.Km' value={CarData.Km || ''} onChange={this.onChange} onBlur={this.onBlur} helpText={translation(16846)} placeholder={translation(860)} />
            <Textarea name='CarData.DamageComment' placeholder={translation(1021)} value={CarData.DamageComment || ''} onChange={this.onChange} onBlur={this.onBlur} />

            <Text className={this.state.regNumberError ? 'required' : ''} name='CarData.RegNumber' value={CarData.RegNumber || ''} onChange={this.onRegNrChange} onBlur={this.onRegBlur} placeholder={translation(2005)} />

            <DropDown className={requiredBrandNameClass} name='CarData.BrandNameId' value={CarData.BrandNameId} onChange={this.onChange}>
              {this.props.Brands.map((val, index) => {
                let brandName = val.Id === 1 ? translation(val.Name) : val.Name
                return val.Id === this.state.CarData.BrandNameId ? <option value={val.Id} key={index} selected>{brandName}</option> : <option value={val.Id} key={index}>{brandName}</option>
              })}
            </DropDown>
            <Text className={requiredModelClass} name='CarData.Model' value={CarData.Model || ''} onChange={this.onChange} onBlur={this.onBlur} placeholder={translation(146)} />
            <Text name='CarData.ChassisNumber' value={CarData.ChassisNumber || ''} onChange={this.onChange} onBlur={this.onBlur} helpText={translation(16845)} placeholder={translation(81)} />
            <div className='ctaWrapper'>
              <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} leftChildren={leftChildren}>
                <Icon
                  size='s'
                  icon={EmbeddedBookingIcons.Left_Arrow}
                  injectSvg
                />
              </Button>
              <Button labelText={translation(237)} onClick={(e) => this.checkAndNav(e, 'next')}>
                <Icon
                  size='s'
                  icon={EmbeddedBookingIcons.Right_Arrow}
                  injectSvg
                />
              </Button>
            </div>
          </article>
          <aside className='side'>
            <section>
              <h1>{translation(18432)}</h1>
              <p>{translation(18433)}</p>
              <ul>
                <li>{translation(18434)}</li>
                <li>{translation(18435)}</li>
                <li>{translation(18436)}</li>
              </ul>
            </section>
          </aside>
        </div>
      )
    }

    return (
      <div className='car-data__view'>
        {this.props.flowType === 'with_regnr' ? renderWithRegFlow() : renderNoRegFlow()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    Brands: state.common.brands,
    CarData: state.embeddedbooking.CarData,
    EmbeddedBooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, { setEmbeddedBookingCardata, saveEmbeddedBooking, getOrderVehicleData })(CarDataView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/CarDataView/index.js